import React, {Component} from 'react';
import CustomForm from "../../../shared/components/form/CustomForm";
import {StartVacationConfig} from "../../../shared/components/form/VacationConfig";

class StartVacation extends Component {

  render() {
    let [today] = (new Date()).toISOString().split('T')
    return (
      <div>
        <CustomForm
          config={StartVacationConfig}
          initialValues={{
            start: today
          }}
          onSubmit={(data) => this.props.onSubmit(data)}
        />
      </div>
    )
  }
}

export default StartVacation;
